export const DEFAULT_ATTRS: Attrs = {
	enabled: true,
	includeNames: false,
};

export type Attrs = {
	readonly enabled: boolean;
	readonly includeNames: boolean;
};

export type SetAttrs = ( attrs: Partial< Attrs > ) => void;
